/* prettier-ignore */

import { CommonModule } from '@angular/common';
import { Component, inject, Input, ViewEncapsulation } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { RestService } from 'src/app/services/rest.service';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule
  ],
  templateUrl: './event-qr.component.html',
  styleUrls: ["./event-qr.component.scss"],
  encapsulation: ViewEncapsulation.None,
})

export class EventQRComponent {
  @Input("qrCode") qrCode?;
  @Input("item") item?;
  @Input("user") user?;

  public rest = inject(RestService);
  public translate = inject(TranslateService);

}